import React, { Fragment } from 'react'
import { Timeline, Typography } from 'antd'
import { map } from 'lodash'

import { EVENT_SUBTYPES, EVENT_TYPES } from '../../common/constants'
import {
  renderSimpleUpdateEvent,
  renderTreeSaveEvent,
} from '../../common/helpers'
import { formatCreatedByText } from '../../common/utils'

const renderAllergenEvent = event => {
  const { type, subtype, original, changes, createdAt, createdBy } = event

  if (type === EVENT_TYPES.SAVE) {
    return renderTreeSaveEvent(event)
  }

  if (subtype === EVENT_SUBTYPES.INCLUDED_ALLERGENS_CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Created included allergens for {changes.name}:
        </Typography.Text>
        <br />
        {map(changes.includedAllergens, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.INCLUDED_ALLERGENS_DELETE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Deleted included allergens from {original.name}:
        </Typography.Text>
        <br />
        {map(original.includedAllergens, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.INCLUDED_INGREDIENTS_CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Created included ingredients for {changes.name}:
        </Typography.Text>
        <br />
        {map(changes.includedIngredients, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.INCLUDED_INGREDIENTS_DELETE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Deleted included ingredient from {original.name}:
        </Typography.Text>
        <br />
        {map(original.includedIngredients, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  return renderSimpleUpdateEvent(event, 'name')
}

export default renderAllergenEvent
